'use client';
import { Config } from 'constants/config';
import { createContext, JSX, ReactNode, useContext } from 'react';
import { requireNonNull } from 'utils/functions';
import { BrandId } from 'utils/override';

export type ClientContext = {
  readonly authEndpoint: Config['auth']['endpoint'];
  /** The id of the current brand (market) */
  readonly brand: BrandId;
  /** The language range for the current page, same as <html lang> */
  readonly lang: string;
  /** The path prefix for the current language, either an empty string or prefixed with a slash (/) */
  readonly langPrefix: string;
  /** The currency display for the current brand/market */
  readonly currencyDisplay: string;
  /** The client host  */
  readonly host: string;
};

export const Context = createContext<ClientContext | null>(null);

/** The context for the current page */
export function useClientContext(): ClientContext {
  return requireNonNull(useContext(Context), 'Client context is not set');
}

// Provide a wrapper so the context can be set from a server component
export function ClientContextProvider_internal(props: {
  value: ClientContext;
  children: ReactNode;
}): JSX.Element {
  return (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
  );
}
